<script lang="ts" setup>
import { useMediaControls } from "@vueuse/core";

const appConfig = useAppConfig();

const audio = useTemplateRef("audio");
const { playing } = useMediaControls(audio, {
  src: {
    type: "audio/mp3",
    src: appConfig.template.others.music.src,
  },
});

function onTogglePlay() {
  playing.value = !playing.value;
}

defineExpose({
  onTogglePlay,
});
</script>

<template>
  <audio
    ref="audio"
    preload="auto"
    loop
    controls
    controlslist="nodownload noremoteplayback nofullscreen"
    class="hidden"
  />
  <UButton
    class="rounded-full w-max"
    size="xl"
    :icon="playing ? 'i-lucide-pause' : 'i-lucide-play'"
    @click="onTogglePlay"
  />
</template>
